var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"svv-events-list-view-mode-selector"},[_c('a',{staticClass:"svv-events-list-view-mode-selector-item",class:{
      'svv-active-view-mode':
        _vm.widgetSettings.widget_style_settings.ew_events_list_view === 'list' ||
        (_vm.widgetSettings.widget_style_settings.ew_events_list_view ===
          'progressive' &&
          _vm.eventsPorgressiveView === 'list'),
    },attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return (() => _vm.setEventsListViewMode('list')).apply(null, arguments)}}},[_c('ListViewIcon',{staticClass:"svv-view-mode-icon svv-list-view-mode"})],1),_c('a',{staticClass:"svv-events-list-view-mode-selector-item",class:{
      'svv-active-view-mode':
        _vm.widgetSettings.widget_style_settings.ew_events_list_view === 'grid' ||
        (_vm.widgetSettings.widget_style_settings.ew_events_list_view ===
          'progressive' &&
          _vm.eventsPorgressiveView === 'grid'),
    },attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return (() => _vm.setEventsListViewMode('grid')).apply(null, arguments)}}},[_c('TableViewIcon',{staticClass:"svv-view-mode-icon svv-table-view-mode"})],1),(_vm.windowSize !== 'mobile')?_c('a',{staticClass:"svv-events-list-view-mode-selector-item",class:{
      'svv-active-view-mode':
        _vm.widgetSettings.widget_style_settings.ew_events_list_view ===
        'calendar',
    },attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.onCalendarClick.apply(null, arguments)}}},[_c('Calendar',{staticClass:"svv-view-mode-icon svv-table-view-mode"})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }